import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    // 首页
    {
        path: '/',
        name: 'Home',
        meta: { title: '企业注册入驻_新华英才招聘-大学生就业服务平台' },
        component: () =>
            import(/* webpackChunkName: "home" */ '../views/Home.vue')
    },
    // 登录
    {
        path: '/login',
        name: 'Login',
        meta: { title: '企业登录_新华英才招聘-大学生就业服务平台' },
        component: () =>
            import(/* webpackChunkName: "login" */ '../views/Login.vue')
    },
    // 注册
    {
        path: '/signup',
        name: 'Signup',
        meta: { title: '企业注册入驻_新华英才招聘-大学生就业服务平台' },
        component: () =>
            import(/* webpackChunkName: "signup" */ '../views/Signup.vue')
    }
];

const router = new VueRouter({
    routes
});
router.beforeEach((to, from, next) => {
    document.title = to.meta.title || '中华英才网';
    window.clickLog &&
        window.clickLog(`from=newtalent_register_${to.name}_show`);
    next();
});

export default router;
